export class BlobInfo {
  constructor(file: Blob, contentLength: number) {
    this.file = file
    this.contentLength = contentLength
  }

  file: Blob
  contentLength: number
}
